import * as React from "react";
import { Map } from "ol";
import mammaImage from "../../img/basemaps/mamma.png";
import ortoImage from "../../img/basemaps/orto2.png";
import { useAppContext } from "../../Contexts/AppContext";
import { config } from "../config";
import { Basemaps } from "../enums";

export const BasemapSwitch = ({ map }: { map: Map }): JSX.Element => {
    const { basemap, setBasemap } = useAppContext();

    return (
        <div id="basemap-toggle" className="pubevents-map-button ol-unselectable ol-control">
            {config.basemaps.map((baseMap) =>
                basemap !== (baseMap.id as Basemaps) ? (
                    <button
                        id={baseMap.id}
                        onClick={() => setBasemap(baseMap.id as Basemaps)}
                        title={baseMap.title}
                        key={"basemap-" + baseMap.id}
                    >
                        <img src={baseMap.id === Basemaps.Orto ? ortoImage : mammaImage} />
                    </button>
                ) : null
            )}
        </div>
    );
};
